






















import {Component, Prop, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import Loader from "@/components/Loader.vue";
import ResultArray from "../Results/ResultArray";
import Result from "../Results/Result";
import ResultCmpt from "../Results/ResultCmpt.vue";

@Component({
    components: {
        ResultCmpt,
        Loader,
    }
})
export default class Results extends Vue {
    @Getter("results") public results!: ResultArray;
    @Prop({type: Object}) public selected!: Result;
    public currentResult: Result | null = null;

    mounted() {
        if (this.selected) {
            this.currentResult = this.selected;
        }
    }

    select(result: Result) {
        this.currentResult = result;
    }

    closeResult() {
        if (this.currentResult) {
            this.currentResult = null;
        }
    }

    getErrorsClass(result: Result): string {
        return result.errorsCount > 2 ? "badge-danger" : "badge-success";
    }
}
